<div class="mt-6 flex flex-col md:flex-row md:items-start gap-6">
  <!-- GAUCHE (Détails, qui prend le plus de place) -->
  <div class="flex-auto">
    <div id="building-resume-details-card" class="card">
      <div class="px-gutter py-4 border-b flex justify-between items-center">
        <h2 class="title m-0">Détails</h2>

        <button
          color="primary"
          mat-raised-button
          type="button"
          (click)="updateItem()"
          *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
        >
          MODIFIER
        </button>
      </div>

      <div
        *ngIf="(buildingService.entity$ | async)?._id; else loading"
        class="px-gutter py-4"
        gdColumns="1fr 1fr"
        gdColumns.xs="1fr"
        gdGap="16px"
      >
        <details-line-base
          hint="Bâtiment générique"
          [label]="(buildingService.entity$ | async).genericBuilding?.label"
        ></details-line-base>

        <details-line-base
          hint="Catégorie générique de bâtiment"
          [label]="(buildingService.entity$ | async).genericBuildingCategory?.label"
        ></details-line-base>

        <div gdColumn="1 / -1" class="mt-2" *ngIf="buildingService.entity$ | async as building">
          <p class="caption text-secondary mb-1">Référent en charge de la supervision</p>
          <default-supervision-resolved
            *ngIf="building.genericBuilding?._id"
            [metrikType]="metrikTypeEnum.BUILDING"
            [genericNodeId]="building.genericBuilding?._id"
            [establishments]="building.establishments || []"
            [manualContact]="building.contactIntern"
          ></default-supervision-resolved>
        </div>

        <details-line-base
          hint="Identifiant Technique"
          [label]="(buildingService.entity$ | async).technicalIdentifier"
        ></details-line-base>

        <details-line-base
          hint="Libellé"
          [label]="(buildingService.entity$ | async).label | uppercase"
        ></details-line-base>

        <details-line-base
          hint="Dénomination client"
          [label]="(buildingService.entity$ | async).customerDesignation | uppercase"
        ></details-line-base>

        <details-line-base
          hint="Date de construction"
          [label]="(buildingService.entity$ | async).constructionDate"
          type="date"
        ></details-line-base>

        <details-line-base
          hint="Type de détention"
          [label]="(buildingService.entity$ | async).detentionType?.label"
        ></details-line-base>

        <details-line-base
          *ngIf="(buildingService.entity$ | async).supplier"
          hint="Bailleur / Propriétaire"
          [label]="(buildingService.entity$ | async).supplier?.label"
        ></details-line-base>

        <details-line-base
          *ngIf="(buildingService.entity$ | async).leaseType"
          hint="Type bail"
          [label]="(buildingService.entity$ | async).leaseType?.label"
        ></details-line-base>

        <details-line-base
          hint="Surface Totale (m²)"
          [label]="(buildingService.entity$ | async).surface"
        ></details-line-base>

        <details-line-base
          hint="Surface disponible (m²)"
          [label]="(buildingService.entity$ | async)?.availableSurface"
        ></details-line-base>
      </div>

      <div class="px-gutter py-4 border-b flex flex-row justify-between items-center">
        <h2 class="title m-0">Statut de fonctionnement</h2>
        <span *ngIf="!hasDefinitiveMetrik(buildingService.entity$ | async)">
          <button
            color="primary"
            mat-raised-button
            type="button"
            (click)="createMetrikStatus()"
            *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
          >
            AJOUTER
          </button>
        </span>
      </div>
      <vex-history [events]="historiqueData"></vex-history>

      <div class="px-gutter py-4 border-b flex flex-row justify-between items-center">
        <h2 class="title m-0">Dates de dernière maintenance</h2>
      </div>
      <div class="px-gutter py-4" gdColumns="1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
        <details-line-base
          hint="Maintenance réglementaire"
          [label]="(buildingService.entity$ | async)?.lastRegulatoryMaintenanceDate"
          type="date"
        ></details-line-base>
        <details-line-base
          hint="Maintenance non réglementaire"
          [label]="(buildingService.entity$ | async)?.lastMaintenanceDateOther"
          type="date"
        ></details-line-base>
      </div>
    </div>
  </div>

  <!-- DROITE (Actions + Étages, qui prend moins de place) -->
  <div class="w-full md:max-w-md flex-none">
    <div *ngIf="entity" class="card mb-3" [ngClass]="{ 'end-service-completed': hasDefinitiveMetrik(entity) }">
      <h2 class="title m-0 mr-2 p-4 border-b">Fin de service définitive</h2>
      <div class="px-4 py-4 flex flex-col gap-6">
        <!-- Bouton toujours visible, désactivé par défaut et activé uniquement si toutes les conditions sont remplies -->
        <button
          (click)="setEndServiceDate()"
          class="w-full"
          color="primary"
          [disabled]="!isAddEndServiceButtonEnabled || hasDefinitiveMetrik(entity)"
          [permissionBlock]="ENUM_PERMISSIONS.UPDATE_BUILDING"
          mat-raised-button
        >
          AJOUTER UNE DATE DE FIN DE SERVICE
        </button>

        <!-- Loader pendant le chargement de la checklist -->
        <div *ngIf="isLoadingChecklist" class="mt-4 flex justify-center items-center py-8">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <!-- Checklist conditionnelle -->
        <div *ngIf="!isLoadingChecklist && showChecklist && endServicePreparationData" class="mt-4">
          <!-- 1. État des lieux de sortie -->
          <div class="checklist-section mb-4">
            <mat-checkbox [checked]="checklist?.hasInventoryDocument" disabled>
              <strong class="text-xs">ÉTAT DES LIEUX DE SORTIE</strong>
            </mat-checkbox>
          </div>

          <!-- 2. Résiliation des points de livraison d'énergie -->
          <div *ngIf="getEnergyTypes().length > 0" class="checklist-section mb-4">
            <div class="mb-2">
              <strong class="text-xs">RÉSILIATION DES POINTS DE LIVRAISON D'ÉNERGIE</strong>
            </div>
            <div *ngFor="let energyType of getEnergyTypes(); trackBy: trackByString" class="ml-2">
              <div class="text-xs font-medium mb-1">{{ energyType }}</div>
              <div
                *ngFor="let point of getEnergyPointsByType(energyType); trackBy: trackById"
                class="ml-4 text-xs mb-2"
              >
                <label class="flex items-center gap-2">
                  <input
                    type="checkbox"
                    [checked]="isChecklistItemChecked('energyPointsHandled', point._id)"
                    (click)="onCheckboxClick($event, 'energyPointsHandled', point._id)"
                    [disabled]="hasDefinitiveMetrik(entity)"
                    class="cursor-pointer"
                  />

                  <!-- Lien cliquable si l'énergie existe encore -->
                  <span
                    *ngIf="!isItemDisappeared(point._id)"
                    (click)="scrollToEnergiesSection($event)"
                    class="text-blue-600 underline cursor-pointer hover:text-blue-800"
                  >
                    {{ point.label }} ({{ point.establishment }})
                    <mat-icon class="text-xs ml-1" inline>open_in_new</mat-icon>
                  </span>

                  <!-- Texte barré grisé si l'énergie a été supprimée -->
                  <span *ngIf="isItemDisappeared(point._id)" class="text-gray-400 line-through">
                    {{ point.label }} ({{ point.establishment }})
                    <mat-icon class="text-xs ml-1" inline>history</mat-icon>
                  </span>
                </label>
              </div>
            </div>
          </div>

          <!-- 3. Adresse principale à modifier -->
          <div *ngIf="getAllEstablishmentsWithMainAddress().length > 0" class="checklist-section mb-4">
            <div class="mb-2">
              <strong class="text-xs">ADRESSE PRINCIPALE À MODIFIER</strong>
            </div>
            <div
              *ngFor="let est of getAllEstablishmentsWithMainAddress(); trackBy: trackById"
              class="ml-4 text-xs mb-2"
            >
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="isChecklistItemChecked('principalAddressesUpdated', est._id)"
                  (click)="onCheckboxClick($event, 'principalAddressesUpdated', est._id)"
                  [disabled]="hasDefinitiveMetrik(entity)"
                  class="cursor-pointer"
                />
                <a
                  (click)="navigateToEstablishment(est._id, $event)"
                  class="text-blue-600 underline cursor-pointer hover:text-blue-800"
                  [class.line-through]="isItemDisappeared(est._id)"
                  [class.text-gray-400]="isItemDisappeared(est._id)"
                >
                  {{ est.technicalIdentifier }} / {{ est.label }}
                  <mat-icon class="text-xs ml-1" inline>open_in_new</mat-icon>
                </a>
              </label>
              <mat-icon *ngIf="isItemDisappeared(est._id)" class="text-gray-400 text-xs ml-6" inline>history</mat-icon>
            </div>
          </div>

          <!-- 4. Déclaration changement adresse principale sous FINESS -->
          <div *ngIf="getAllEstablishmentsWithFiness().length > 0" class="checklist-section mb-4">
            <div class="mb-2">
              <strong class="text-xs">DÉCLARATION CHANGEMENT ADRESSE PRINCIPALE D'ÉTABLISSEMENT SOUS FINESS</strong>
            </div>
            <div *ngFor="let est of getAllEstablishmentsWithFiness(); trackBy: trackById" class="ml-4 text-xs mb-2">
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  [checked]="isChecklistItemChecked('finessDeclarations', est._id)"
                  (click)="onCheckboxClick($event, 'finessDeclarations', est._id)"
                  [disabled]="hasDefinitiveMetrik(entity)"
                  class="cursor-pointer"
                />
                <a
                  (click)="navigateToEstablishment(est._id, $event)"
                  class="text-blue-600 underline cursor-pointer hover:text-blue-800"
                  [class.line-through]="isItemDisappeared(est._id)"
                  [class.text-gray-400]="isItemDisappeared(est._id)"
                >
                  {{ est.technicalIdentifier }} / {{ est.label }} / {{ est.finess }}
                  <mat-icon class="text-xs ml-1" inline>open_in_new</mat-icon>
                </a>
              </label>
              <mat-icon *ngIf="isItemDisappeared(est._id)" class="text-gray-400 text-xs ml-6" inline>history</mat-icon>
            </div>
          </div>

          <!-- Bouton Actions réalisées -->
          <button
            *ngIf="!checklist?.allActionsCompleted && !hasDefinitiveMetrik(entity)"
            (click)="onActionsCompleted()"
            [disabled]="isValidatingActions || !areAllRequiredActionsChecked || hasDefinitiveMetrik(entity)"
            class="w-full mt-4"
            color="accent"
            mat-raised-button
          >
            <mat-spinner *ngIf="isValidatingActions" diameter="20" class="inline-block mr-2"></mat-spinner>
            <span *ngIf="!isValidatingActions">ACTIONS RÉALISÉES</span>
            <span *ngIf="isValidatingActions">VALIDATION EN COURS...</span>
          </button>

          <!-- Message de confirmation -->
          <div *ngIf="checklist?.allActionsCompleted" class="mt-4 p-3 bg-green-100 rounded flex items-center">
            <mat-icon class="text-green-600">check_circle</mat-icon>
            <span class="ml-2 text-xs">
              Toutes les actions préalables ont été complétées le
              {{ checklist.completedAt | date: 'dd/MM/yyyy à HH:mm' }}
            </span>
          </div>

          <!-- Message de fin de service définitive -->
          <div *ngIf="hasDefinitiveMetrik(entity)" class="mt-4 p-3 bg-gray-200 rounded flex items-center">
            <mat-icon class="text-gray-600">event_busy</mat-icon>
            <span class="ml-2 text-xs text-gray-700 font-semibold">Fin de service définitive enregistrée.</span>
          </div>
        </div>
      </div>
    </div>

    <div id="building-resume-floors-card" class="card">
      <div class="px-6 py-4 border-b flex flex-row justify-between">
        <h2 class="title m-0">Étages</h2>

        <button
          *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
          (click)="createStage()"
          class="ml-4"
          color="primary"
          mat-mini-fab
          matTooltip="Ajouter un étage"
          type="button"
        >
          <mat-icon [icIcon]="icAdd"></mat-icon>
        </button>
      </div>

      <base-data-table
        (onDeleteItem)="deleteItemStage($event)"
        (onUpdateItem)="updateItemStage($event)"
        [dataSource]="dataSourceStage"
        [displayedColumns]="displayedColumnsStage"
        [feisColumns]="feisColumnsStage"
        [showPaginator]="false"
      ></base-data-table>
    </div>

    <div id="building-resume-energies-card" class="card mt-6">
      <div class="px-6 py-4 border-b flex flex-row justify-between">
        <h2 class="title m-0">Energies</h2>

        <button
          *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
          (click)="createEnergy()"
          class="ml-4"
          color="primary"
          mat-mini-fab
          matTooltip="Ajouter une énergie"
          type="button"
        >
          <mat-icon [icIcon]="icAdd"></mat-icon>
        </button>
      </div>

      <base-data-table
        (onDeleteItem)="deleteItemEnergy($event)"
        (onUpdateItem)="updateItemEnergy($event)"
        [dataSource]="dataSourceEnergy"
        [displayedColumns]="displayedColumnsEnergy"
        [feisColumns]="feisColumnsEnergy"
        [showPaginator]="false"
      ></base-data-table>
    </div>
  </div>
</div>

<ng-container>
  <div id="building-resume-adresses-card" class="bg-white rounded-lg shadow-md overflow-hidden mt-6">
    <!-- Header Section -->
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <mat-icon class="text-blue-600">location_on</mat-icon>
          <h2 class="text-xl font-semibold text-gray-800 m-0">Adresses du bâtiment</h2>
        </div>
        <button
          *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
          (click)="createAddress()"
          color="primary"
          mat-raised-button
        >
          AJOUTER UNE ADRESSE
        </button>
      </div>
    </div>

    <!-- Content Section -->
    <div class="p-6">
      <!-- Empty State -->
      <div *ngIf="!dataSourceAddress?.data?.length" class="text-center py-12">
        <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mb-4">
          <mat-icon class="text-gray-400 text-2xl">location_off</mat-icon>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">Aucune adresse</h3>
        <p class="text-gray-500 mb-6">Commencez par ajouter une adresse pour ce bâtiment.</p>
      </div>

      <!-- Vue Tableau -->
      <div *ngIf="dataSourceAddress?.data?.length" class="overflow-hidden">
        <base-data-table
          (onDeleteItem)="deleteAddress($event)"
          (onPageEvent)="pageEventAddress($event)"
          (onSortEvent)="sortEventAddress($event)"
          (onUpdateItem)="updateAddress($event)"
          (onSelectedRow)="favoriteMainAddress($event)"
          [count]="countAddress"
          [dataSource]="dataSourceAddress"
          [displayedColumns]="displayedColumnsAddress"
          [feisColumns]="feisColumnsAddress"
          [pageSize]="pageSizeAddress || 10"
          [sortField]="sortFieldAddress"
          [sortOrder]="sortOrderAddress"
          [pageSizeOptions]="[5, 10, 25, 50]"
          class="rounded-lg border border-gray-200 overflow-hidden"
        ></base-data-table>
      </div>
    </div>
  </div>
</ng-container>

<ng-container>
  <div id="building-resume-establishments-card" class="card mt-6">
    <div class="px-6 py-4 border-b flex flex-row justify-between">
      <h2 class="title m-0">
        Établissements
        <icon-warning
          [show]="hasEstablishmentWarnings"
          [toolTip]="combinedEstablishmentWarningTooltip"
          class="ml-2"
        ></icon-warning>
      </h2>

      <button
        *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
        (click)="addItemEstablishment()"
        class="ml-4"
        color="primary"
        fxFlex="none"
        mat-mini-fab
        matTooltip="Ajouter un établissement"
        type="button"
      >
        <mat-icon [icIcon]="icAdd"></mat-icon>
      </button>
    </div>

    <base-data-table
      (onDeleteItem)="deleteItemEstablishment($event)"
      (onUpdateItem)="updateItemEstablishment($event)"
      (onSelectedRow)="favoriteItemEstablishment($event)"
      [dataSource]="dataSourceEstablishment"
      [displayedColumns]="displayedColumnsEstablishment"
      [feisColumns]="feisColumnsEstablishment"
      [routerLinkDetailRow]="routerLinkEstablishment"
      [showPaginator]="false"
    ></base-data-table>
  </div>
</ng-container>

<ng-container>
  <div class="mt-6 card">
    <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
      <h2 class="title m-0">
        Activités
        <icon-warning
          [show]="displayActivityWarning"
          [toolTip]="
            'La surface des activités saisies ne correspond pas à la surface totale saisie du bâtiment. (Surface total : ' +
            (buildingService.entity$ | async)?.surface +
            ' m²)'
          "
          class="ml-2"
        ></icon-warning>
      </h2>
    </div>

    <base-data-table
      [dataSource]="dataSourceActivity"
      [displayedColumns]="displayedColumnsActivity"
      [feisColumns]="feisColumnsActivity"
      [showPaginator]="false"
    ></base-data-table>
  </div>
</ng-container>

<ng-template #loading>
  <div class="px-gutter py-4" gdColumns="1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
    <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
      <vex-skeleton [circle]="true" class="w-14 mr-2" heigthTailwind="h-12"></vex-skeleton>
      <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
    </div>

    <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
      <vex-skeleton [circle]="true" class="w-14 mr-2" heigthTailwind="h-12"></vex-skeleton>
      <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
    </div>

    <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
      <vex-skeleton [circle]="true" class="w-14 mr-2" heigthTailwind="h-12"></vex-skeleton>
      <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
    </div>
  </div>
</ng-template>
